var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FFD822"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 5.625H6.375V3.375C6.375 3.27554 6.33549 3.18016 6.26516 3.10984C6.19484 3.03951 6.09946 3 6 3C5.90054 3 5.80516 3.03951 5.73484 3.10984C5.66451 3.18016 5.625 3.27554 5.625 3.375V5.625H3.375C3.27554 5.625 3.18016 5.66451 3.10984 5.73484C3.03951 5.80516 3 5.90054 3 6C3 6.09946 3.03951 6.19484 3.10984 6.26516C3.18016 6.33549 3.27554 6.375 3.375 6.375H5.625V8.625C5.625 8.72446 5.66451 8.81984 5.73484 8.89017C5.80516 8.96049 5.90054 9 6 9C6.09946 9 6.19484 8.96049 6.26516 8.89017C6.33549 8.81984 6.375 8.72446 6.375 8.625V6.375H8.625C8.72446 6.375 8.81984 6.33549 8.89017 6.26516C8.96049 6.19484 9 6.09946 9 6C9 5.90054 8.96049 5.80516 8.89017 5.73484C8.81984 5.66451 8.72446 5.625 8.625 5.625Z",
    fill: "#212529",
    stroke: "#212529",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.0472183a2af9d8e738a39af9f2c37667.svg";
export { ForwardRef as ReactComponent };